import { getApiInternalClient } from '..';
import getSession from '../../utilities/getSession';
import withAuthenticationHeaders from '../../utilities/withAuthenticationHeaders';

type CancelPaymentRequestActionParams = {
  id: string;
  reasonCode?: io.flow.v0.enums.PaymentFailureCode;
  data?: any;
};

export default function cancelPaymentRequestAction(
  {
    id,
    reasonCode,
    data,
  }: CancelPaymentRequestActionParams,
): Promise<io.flow.internal.v0.models.InternalPaymentRequest> {
  return getSession().then((session) => getApiInternalClient()
    .paymentRequest.postPaymentAndMethodAndActionAndCancellation({
      id,
      organization: session.organization,
      body: {
        reason_code: reasonCode,
        data,
      },
      headers: withAuthenticationHeaders(session.id),
    }).then((response) => {
      if (response.ok) {
        return response.body;
      }

      throw new Error(`cancelPaymentRequestAction: Failed to cancel PR action, status: ${response.status}`);
    }));
}
